import { render, staticRenderFns } from "./VentasListaCarritoItem.vue?vue&type=template&id=992f9bb0&"
import script from "./VentasListaCarritoItem.vue?vue&type=script&lang=js&"
export * from "./VentasListaCarritoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports